export default "__VITE_ASSET__C0lV21Ir__"